var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFilterIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.995,
    height: 16.995,
    viewBox: "0 0 16.995 16.995",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "filter-icon",
    transform: "translate(-1750 -158)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10131",
    "data-name": "Group 10131",
    transform: "translate(1750 164.07)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10130",
    "data-name": "Group 10130",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_37649",
    "data-name": "Path 37649",
    d: "M16.388,172.488H6.59a2.416,2.416,0,0,0-4.683,0H.607a.607.607,0,1,0,0,1.214h1.3a2.416,2.416,0,0,0,4.683,0h9.8a.607.607,0,1,0,0-1.214Z",
    transform: "translate(0 -170.667)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_10133",
    "data-name": "Group 10133",
    transform: "translate(1750 158)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10132",
    "data-name": "Group 10132",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_37650",
    "data-name": "Path 37650",
    d: "M16.388,1.821H14.481a2.416,2.416,0,0,0-4.683,0H.607a.607.607,0,1,0,0,1.214H9.8a2.416,2.416,0,0,0,4.683,0h1.907a.607.607,0,1,0,0-1.214Z",
    transform: "translate(0 0)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_37651",
    "data-name": "Path 37651",
    d: "M16.388,343.155H13.267a2.416,2.416,0,0,0-4.683,0H.607a.607.607,0,1,0,0,1.214H8.584a2.416,2.416,0,0,0,4.683,0h3.121a.607.607,0,1,0,0-1.214Z",
    transform: "translate(1750 -171.194)",
    fill: "#fff"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterIcon);
export default __webpack_public_path__ + "static/media/filter-icon.84c342d5.svg";
export { ForwardRef as ReactComponent };